import { useQuery } from '@tanstack/react-query';
import { IObject } from 'types';
import { useApi } from './useApi';

export const useObjects = () => {
  const api = useApi();
  return useQuery<IObject[]>(['objects'], () => api.getObjects());
};
